import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import Vue from "vue";

Vue.use(Viewer, {
  defaultOptions: {
    toolbar: {
      zoomIn: 1,
      zoomOut: 1,
      oneToOne: 0,
      reset: 0,
      prev: 1,
      play: {
        show: 1,
        size: "large"
      },
      next: 1,
      rotateLeft: 1,
      rotateRight: 1,
      flipHorizontal: 0,
      flipVertical: 0
    },
    button: true,
    navbar: true,
    title: false,
    tooltip: true,
    movable: true,
    zoomable: true,
    rotatable: true,
    scalable: false,
    transition: true,
    fullscreen: true,
    keyboard: false
  }
});
